import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface OrderOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-order-by',
  templateUrl: './order-by.component.html',
  styleUrls: ['./order-by.component.scss']
})
export class OrderByComponent {

  @Input() options: OrderOption[] = [
    { value: 'DESC', label: 'Fecha más reciente' },
    { value: 'ASC', label: 'Fecha más antigua' },
    { value: '03|name|ASC', label: 'Nombre ascendente' },
    { value: '04|name|DESC', label: 'Nombre descendente' }
  ];

  @Input() selectedValue: string = this.options[0]?.value ?? '';

  @Output() orderChanged = new EventEmitter<string>();

  selectOrder(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    this.orderChanged.emit(value);
  }
}
